import {
  PROCESS_STATEMENT_UPLOAD_INITIATED,
  PROCESS_STATEMENT_UPLOAD_SUCCESS,
  PROCESS_STATEMENT_UPLOAD_FAILED,
  PROCESS_STATEMENT_FILES_INITIATED,
  PROCESS_STATEMENT_FILES_LOADED,
  PROCESS_STATEMENT_FILES_FAILED,
  PROCESS_STATEMENT_RECORDS_INITIATED,
  PROCESS_STATEMENT_RECORDS_LOADED,
  PROCESS_STATEMENT_RECORDS_FAILED,
  PROCESS_STATEMENT_REPROCESS_INITIATED,
  PROCESS_STATEMENT_REPROCESS_SUCCESS,
  PROCESS_STATEMENT_REPROCESS_FAILED,
  PROCESS_STATEMENT_REPROCESS_ALL_INITIATED,
  PROCESS_STATEMENT_REPROCESS_ALL_SUCCESS,
  PROCESS_STATEMENT_REPROCESS_ALL_FAILED,
  PROCESS_STATEMENT_LOGS_INITIATED,
  PROCESS_STATEMENT_LOGS_LOADED,
  PROCESS_STATEMENT_LOGS_FAILED,
} from '../actions/ProcessStatementAction';

const initialState = {
  filesList: [],
  recordsList: [],
  reprocessLogs: [],
  uploadResult: null,
  reprocessResult: null,
  reprocessAllResult: null,
  loading: false,
  uploadLoading: false,
  reprocessLoading: false,
  reprocessAllLoading: false,
  logsLoading: false,
  error: null,
};

const ProcessStatementReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROCESS_STATEMENT_UPLOAD_INITIATED:
      return { ...state, uploadLoading: true, uploadResult: null, error: null };
    case PROCESS_STATEMENT_UPLOAD_SUCCESS:
      return { ...state, uploadLoading: false, uploadResult: action.payload };
    case PROCESS_STATEMENT_UPLOAD_FAILED:
      return { ...state, uploadLoading: false, error: action.payload };

    case PROCESS_STATEMENT_FILES_INITIATED:
      return { ...state, loading: true, error: null };
    case PROCESS_STATEMENT_FILES_LOADED:
      return { ...state, loading: false, filesList: action.payload || [] };
    case PROCESS_STATEMENT_FILES_FAILED:
      return { ...state, loading: false, error: action.payload };

    case PROCESS_STATEMENT_RECORDS_INITIATED:
      return { ...state, loading: true, error: null };
    case PROCESS_STATEMENT_RECORDS_LOADED:
      return { ...state, loading: false, recordsList: action.payload || [] };
    case PROCESS_STATEMENT_RECORDS_FAILED:
      return { ...state, loading: false, error: action.payload };

    case PROCESS_STATEMENT_REPROCESS_INITIATED:
      return { ...state, reprocessLoading: true, reprocessResult: null, error: null };
    case PROCESS_STATEMENT_REPROCESS_SUCCESS:
      return { ...state, reprocessLoading: false, reprocessResult: action.payload };
    case PROCESS_STATEMENT_REPROCESS_FAILED:
      return { ...state, reprocessLoading: false, error: action.payload };

    case PROCESS_STATEMENT_REPROCESS_ALL_INITIATED:
      return { ...state, reprocessAllLoading: true, reprocessAllResult: null, error: null };
    case PROCESS_STATEMENT_REPROCESS_ALL_SUCCESS:
      return { ...state, reprocessAllLoading: false, reprocessAllResult: action.payload };
    case PROCESS_STATEMENT_REPROCESS_ALL_FAILED:
      return { ...state, reprocessAllLoading: false, error: action.payload };

    case PROCESS_STATEMENT_LOGS_INITIATED:
      return { ...state, logsLoading: true, error: null };
    case PROCESS_STATEMENT_LOGS_LOADED:
      return { ...state, logsLoading: false, reprocessLogs: action.payload || [] };
    case PROCESS_STATEMENT_LOGS_FAILED:
      return { ...state, logsLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default ProcessStatementReducer;
